import { render, staticRenderFns } from "./pg_company_guide.vue?vue&type=template&id=4e26ed2c"
import script from "./pg_company_guide.vue?vue&type=script&lang=js"
export * from "./pg_company_guide.vue?vue&type=script&lang=js"
import style0 from "./pg_company_guide.vue?vue&type=style&index=0&id=4e26ed2c&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports